import { Navigate, Route, Routes } from 'react-router-dom';

import { useAuth } from './lib/auth.js';
import { AppLinkPage } from './pages/AppLink.js';
import { ConfigDetailPage } from './pages/ConfigDetail.js';
import { DashboardPage } from './pages/Dashboard.js';
import { LoginPage } from './pages/Login.js';

export function App() {
  const auth = useAuth();

  if (auth.status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-slate-500">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-700 border-t-brand" />
          <span>Проверяем сессию…</span>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={auth.status === 'authenticated' ? <DashboardPage /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/configs/:id"
        element={
          auth.status === 'authenticated' ? <ConfigDetailPage /> : <Navigate to="/login" replace />
        }
      />
      <Route
        path="/app"
        element={auth.status === 'authenticated' ? <AppLinkPage /> : <Navigate to="/login" replace />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
